export const catalog_matrix = [
  {form_key:'state_id', catalog_key:'mexico_states'},
  {form_key:'risk_premium_id', catalog_key:'risk_premiums'},
]